import '../../../../avl_package/Resources/Public/JavaScript/modules/kundenportal-iframe';
(() => {
  window.avlKundenportal = window.avlKundenportal || {};
  const langDetails = document.querySelector('[data-portal-lang]');
  if (!langDetails) {
    return;
  }
  const langTrigger = langDetails.querySelector('summary');
  if (!langTrigger) {
    return;
  }
  const setExpanded = () => {
    langTrigger.setAttribute('aria-expanded', langDetails.open ? 'true' : 'false');
  };
  const closeLang = ({
    restoreFocus
  } = {}) => {
    if (!langDetails.open) {
      setExpanded();
      return;
    }
    langDetails.open = false;
    setExpanded();
    if (restoreFocus) {
      langTrigger.focus();
    }
  };
  setExpanded();
  langDetails.addEventListener('toggle', setExpanded);
  document.addEventListener('click', event => {
    if (!langDetails.open) {
      return;
    }
    if (!langDetails.contains(event.target)) {
      closeLang();
    }
  });
  document.addEventListener('focusin', event => {
    if (!langDetails.open) {
      return;
    }
    if (!langDetails.contains(event.target)) {
      closeLang();
    }
  });
  document.addEventListener('keydown', event => {
    if (!langDetails.open) {
      return;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      closeLang({
        restoreFocus: true
      });
    }
  });
  langDetails.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!link) {
      return;
    }
    const menu = langDetails.querySelector('.portal__lang-menu');
    if (menu && menu.contains(link)) {
      closeLang();
    }
  });
})();

// FAQ (avlpackage_accordeon): Auf- und Zuklappen ohne jQuery/Bootstrap-JS.
// Markup aus Partials/ContentElements/Accordeon/*.html,
// sichtbar über .collapse.show (Bootstrap-CSS).
(() => {
  const areas = Array.from(document.querySelectorAll('[data-portal-faq]'));
  if (!areas.length) {
    return;
  }
  const setOpen = (toggle, open) => {
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) {
      return;
    }
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.classList.toggle('show', open);
  };
  areas.forEach(area => {
    const toggles = Array.from(area.querySelectorAll('[data-portal-faq-toggle]'));
    const single = area.hasAttribute('data-portal-faq-single');
    toggles.forEach(toggle => {
      const activate = event => {
        event.preventDefault();
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        if (open && single) {
          toggles.filter(other => other !== toggle).forEach(other => setOpen(other, false));
        }
        setOpen(toggle, open);
      };
      toggle.addEventListener('click', activate);
      // Enter löst auf <a href> nativ click aus; die Leertaste verspricht role="button" zusätzlich.
      toggle.addEventListener('keydown', event => {
        if (event.key === ' ' || event.key === 'Spacebar') {
          activate(event);
        }
      });
    });
  });
})();